var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9896 17.5114C17.1676 18.4614 15.9926 18.9995 14.7486 18.9995C14.7096 18.9995 14.6706 18.9995 14.6316 18.9985C6.64359 18.7815 0.216585 12.3544 0.00158517 4.3674C-0.0334148 3.0704 0.512594 1.84138 1.49859 0.993378C2.43559 0.186378 3.65559 -0.15053 4.84759 0.0624695C5.03059 0.0954695 5.18759 0.137366 5.32159 0.181366C5.84959 0.356366 6.23359 0.813551 6.32159 1.37155L6.99164 5.62643C7.07564 6.15943 6.86762 6.69957 6.45062 7.03757C6.36662 7.10557 6.2796 7.17044 6.1886 7.23044C5.9566 7.38844 5.86859 7.65745 5.97259 7.89645C6.97459 10.2015 8.79463 12.0214 11.0986 13.0234C11.3386 13.1284 11.6076 13.0385 11.7696 12.8015C11.8166 12.7335 11.8656 12.6665 11.9156 12.6025C12.2516 12.1745 12.8026 11.9684 13.3466 12.0554L17.6786 12.7766C18.2506 12.8726 18.7156 13.2775 18.8646 13.8095C18.8916 13.9065 18.9176 14.0166 18.9396 14.1416C19.1486 15.3426 18.8026 16.5694 17.9896 17.5114Z",
    fill: "url(#paint0_linear_1_327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_327",
    x1: 20.8649,
    y1: -1.31623,
    x2: -3.17266,
    y2: 3.65328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#55A7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-Filled.382c488f834c4c502d96de22e915f454.svg";
export { ForwardRef as ReactComponent };